import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container } from 'reactstrap';
import dateFormat from 'dateformat';
/* Models */
import { InventoryEntities } from 'client/data/models/inventory';
/* Utils */
import { addDaysToCurrentDate } from 'site-modules/shared/utils/date-utils';
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';
/* Constants */
import { GO_EXPIRATION_PRE_QUALIFICATION_DAYS } from 'client/site-modules/shared/constants/financing/financing';
/* Components */
import { PaymentCard } from 'site-modules/financing/components/shared/payment-card/payment-card';

function FinancingResultsUI({
  isMobile = false,
  header = '',
  vdpLink = '',
  vehicle = {},
  vin = '',
  isMatchingVIN = false,
  isOffersAvailable = false,
  isLoading = true,
  financingOffers = [],
  calculatorSelections = {},
}) {
  return (
    <div
      className="top-bar-wrapper"
      data-tracking-parent={updateCreativeId({ isMatchingVIN, trackingParent: 'financing_results' })}
    >
      <Container
        className={classNames('financing-container standalone d-flex justify-content-between pos-r', {
          'flex-column px-1_5': isMobile,
        })}
      >
        <div
          className={classNames('top-bar pb-md-3', {
            'text-center': isMobile,
          })}
        >
          {header && <div className="size-30 fw-bold text-white">{header}</div>}
          <div className="mt-0_5 text-white">
            Expires on {dateFormat(addDaysToCurrentDate(GO_EXPIRATION_PRE_QUALIFICATION_DAYS), 'mm-dd-yyyy')}
          </div>
        </div>
        <div
          className={classNames('ms-md-2', {
            'align-self-center': isMobile,
          })}
        >
          <PaymentCard
            vdpLink={vdpLink}
            vehicle={vehicle}
            vin={vin}
            isOffersAvailable={isOffersAvailable}
            isLoading={isLoading}
            financingOffers={financingOffers}
            calculatorSelections={calculatorSelections}
          />
        </div>
      </Container>
    </div>
  );
}

FinancingResultsUI.propTypes = {
  isMobile: PropTypes.bool,
  isMatchingVIN: PropTypes.bool,
  vin: PropTypes.string,
  vehicle: InventoryEntities.InventoryVin,
  vdpLink: PropTypes.string,
  header: PropTypes.string,
  isOffersAvailable: PropTypes.bool,
  isLoading: PropTypes.bool,
  financingOffers: PropTypes.arrayOf(PropTypes.shape({})),
  calculatorSelections: PropTypes.shape({}),
};

export const FinancingResults = React.memo(FinancingResultsUI);
